import axios from "axios";
import React, { useState } from "react";
import { FaTimes, FaUser, FaEnvelope, FaPhone, FaStore, FaKey, FaDesktop } from "react-icons/fa";

const FIELDS = [
  { key:"Name",            label:"Full Name",       type:"text",     icon:<FaUser />,    ph:"e.g. Raj Patel",       full:true },
  { key:"Email",           label:"Email Address",   type:"email",    icon:<FaEnvelope />,ph:"shop@example.com",     full:true },
  { key:"Phone",           label:"Phone Number",    type:"tel",      icon:<FaPhone />,   ph:"+91 98765 43210",      full:false },
  { key:"Shop_Name",       label:"Shop Name",       type:"text",     icon:<FaStore />,   ph:"e.g. Patel Jewellers", full:false },
  { key:"ShopID",          label:"Shop ID",         type:"text",     icon:<FaKey />,     ph:"Unique shop ID",       full:false },
  { key:"Shop_Password",   label:"Shop Password",   type:"password", icon:<FaKey />,     ph:"••••••••",             full:false },
  { key:"ScreenID",        label:"Screen ID",       type:"text",     icon:<FaDesktop />, ph:"Display screen ID",    full:false },
  { key:"Screen_Password", label:"Screen Password", type:"password", icon:<FaKey />,     ph:"••••••••",             full:false },
];

const EMPTY = { Name:"", Email:"", Phone:"", Shop_Name:"", ShopID:"", Shop_Password:"", ScreenID:"", Screen_Password:"" };

const AddUserModal = ({ setUsers }) => {
  const [open, setOpen]       = useState(false);
  const [form, setForm]       = useState(EMPTY);
  const [toast, setToast]     = useState(null);
  const [loading, setLoading] = useState(false);

  const showToast = (msg, type) => { setToast({ msg, type }); setTimeout(() => setToast(null), 3000); };

  const handleChange = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSave = async () => {
    setLoading(true);
    try {
      const res = await axios.post("/server/baos_function/api/register", form);
      if (res.status === 200) {
        setUsers(p => [...p, res.data.data]);
        setForm(EMPTY); setOpen(false);
        showToast("User added successfully!", "success");
      } else { showToast("Failed to add user.", "error"); }
    } catch (e) { console.error(e); showToast("Error adding user.", "error"); }
    finally { setLoading(false); }
  };

  return (
    <>
      <style>{`
        @keyframes aum-toast  { from{opacity:0;transform:translateY(-10px)} to{opacity:1;transform:translateY(0)} }
        @keyframes aum-modal  { from{opacity:0;transform:translateY(22px) scale(.97)} to{opacity:1;transform:translateY(0) scale(1)} }

        .aum-toast {
          position:fixed;top:20px;right:22px;z-index:3000;
          padding:12px 20px;border-radius:12px;font-size:14px;font-weight:500;color:#fff;
          display:flex;align-items:center;gap:10px;animation:aum-toast .3s ease;
          box-shadow:0 8px 24px rgba(0,0,0,.18);max-width:320px;
        }
        .aum-toast.success { background:linear-gradient(135deg,#0B2E33,#4F7C82); }
        .aum-toast.error   { background:linear-gradient(135deg,#931B5B,#6b1443); }

        /* Header bar */
        .aum-hdr-card {
          background:#fff; border-radius:18px; border:1.5px solid #CBCBCB;
          padding:20px 26px; margin-bottom:20px;
          display:flex; align-items:center; justify-content:space-between;
          box-shadow:0 2px 14px rgba(0,0,0,.06); flex-wrap:wrap; gap:12px;
        }
        .aum-hdr-title { font-size:17px; font-weight:700; color:#0B2E33; margin-bottom:2px; }
        .aum-hdr-sub   { font-size:12.5px; color:#6b7280; }
        .aum-open-btn  {
          display:inline-flex; align-items:center; gap:8px;
          background:linear-gradient(135deg,#0B2E33,#4F7C82);
          color:#B8E3E9; border:none; border-radius:12px;
          padding:11px 22px; font-size:13.5px; font-weight:600; cursor:pointer;
          box-shadow:0 4px 14px rgba(11,46,51,.3);
          transition:opacity .2s,transform .2s; white-space:nowrap;
          font-family:'Inter',sans-serif;
        }
        .aum-open-btn:hover { opacity:.9; transform:translateY(-1px); }

        /* Overlay */
        .aum-overlay {
          position:fixed; inset:0; background:rgba(11,46,51,.5);
          z-index:1200; display:flex; align-items:center; justify-content:center;
          padding:20px; backdrop-filter:blur(3px);
        }
        /* Modal */
        .aum-modal {
          background:#fff; border-radius:20px; width:100%; max-width:560px;
          max-height:90vh; overflow-y:auto;
          box-shadow:0 24px 60px rgba(0,0,0,.22);
          animation:aum-modal .28s ease;
        }
        .aum-modal::-webkit-scrollbar       { width:4px; }
        .aum-modal::-webkit-scrollbar-thumb { background:#CBCBCB; border-radius:8px; }

        .aum-modal-hdr {
          display:flex; align-items:center; justify-content:space-between;
          padding:22px 26px 16px; border-bottom:1px solid #F2F2F2;
          position:sticky; top:0; background:#fff; z-index:10; border-radius:20px 20px 0 0;
        }
        .aum-modal-title { font-size:18px; font-weight:700; color:#0B2E33; }
        .aum-modal-sub   { font-size:12px; color:#9ca3af; margin-top:2px; }
        .aum-close-btn {
          width:34px; height:34px; background:#F2F2F2; border:none; border-radius:9px;
          display:flex; align-items:center; justify-content:center;
          font-size:14px; color:#4F7C82; cursor:pointer; transition:background .2s; flex-shrink:0;
        }
        .aum-close-btn:hover { background:#CBCBCB; }

        .aum-modal-body { padding:22px 26px; display:grid; grid-template-columns:1fr 1fr; gap:16px; }
        .aum-fg      { display:flex; flex-direction:column; gap:6px; }
        .aum-fg.full { grid-column:span 2; }
        .aum-lbl {
          font-size:11px; font-weight:700; color:#4F7C82;
          text-transform:uppercase; letter-spacing:.9px;
        }
        .aum-iw {
          display:flex; align-items:center; gap:9px;
          border:1.5px solid #CBCBCB; border-radius:11px;
          padding:10px 13px; background:#F2F2F2;
          transition:border-color .2s,box-shadow .2s;
        }
        .aum-iw:focus-within { border-color:#0B2E33; box-shadow:0 0 0 3px rgba(11,46,51,.1); background:#fff; }
        .aum-ico { color:#CBCBCB; font-size:13px; flex-shrink:0; }
        .aum-iw:focus-within .aum-ico { color:#4F7C82; }
        .aum-inp {
          border:none; background:transparent; outline:none;
          font-size:13.5px; color:#0B2E33; width:100%; font-family:'Open Sans',sans-serif;
        }
        .aum-inp::placeholder { color:#CBCBCB; }

        .aum-modal-ftr {
          padding:16px 26px 22px; border-top:1px solid #F2F2F2;
          display:flex; gap:10px; justify-content:flex-end;
        }
        .aum-cancel {
          padding:10px 20px; border:1.5px solid #CBCBCB; border-radius:11px;
          background:#F2F2F2; color:#0B2E33; font-size:13.5px; font-weight:600;
          cursor:pointer; transition:background .2s; font-family:'Open Sans',sans-serif;
        }
        .aum-cancel:hover { background:#CBCBCB; }
        .aum-save {
          padding:10px 24px; border:none; border-radius:11px;
          background:linear-gradient(135deg,#0B2E33,#4F7C82);
          color:#B8E3E9; font-size:13.5px; font-weight:600; cursor:pointer;
          box-shadow:0 4px 14px rgba(11,46,51,.3); transition:opacity .2s;
          display:flex; align-items:center; gap:8px; font-family:'Open Sans',sans-serif;
        }
        .aum-save:disabled { opacity:.65; cursor:not-allowed; }
        .aum-save:hover:not(:disabled) { opacity:.88; }

        @media(max-width:520px){
          .aum-modal-body { grid-template-columns:1fr; }
          .aum-fg.full    { grid-column:span 1; }
        }
      `}</style>

      {toast && <div className={`aum-toast ${toast.type}`}>{toast.type==="success"?"✅":"❌"} {toast.msg}</div>}

      {/* Header bar */}
      <div className="aum-hdr-card">
        <div>
          <div className="aum-hdr-title">👥 User Management</div>
          <div className="aum-hdr-sub">Register and manage shop owners</div>
        </div>
        <button className="aum-open-btn" onClick={() => setOpen(true)}>+ Add New User</button>
      </div>

      {/* Modal */}
      {open && (
        <div className="aum-overlay" onClick={e => e.target===e.currentTarget && setOpen(false)}>
          <div className="aum-modal">
            <div className="aum-modal-hdr">
              <div>
                <div className="aum-modal-title">Add New User</div>
                <div className="aum-modal-sub">Fill in the details to register a shop owner</div>
              </div>
              <button className="aum-close-btn" onClick={() => setOpen(false)}><FaTimes /></button>
            </div>

            <div className="aum-modal-body">
              {FIELDS.map(f => (
                <div key={f.key} className={`aum-fg ${f.full?"full":""}`}>
                  <label className="aum-lbl">{f.label}</label>
                  <div className="aum-iw">
                    <span className="aum-ico">{f.icon}</span>
                    <input className="aum-inp" type={f.type} name={f.key} value={form[f.key]}
                      onChange={handleChange} placeholder={f.ph} />
                  </div>
                </div>
              ))}
            </div>

            <div className="aum-modal-ftr">
              <button className="aum-cancel" onClick={() => setOpen(false)}>Cancel</button>
              <button className="aum-save" onClick={handleSave} disabled={loading}>
                {loading ? "Saving…" : "✅ Save User"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddUserModal;
